import axios from 'axios'

const axiosAPI = axios.create({
    baseURL: process.env.REACT_APP_API_HOST
});

// Add a request interceptor
axiosAPI.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('authToken');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
        }
        config.headers['Content-Type'] = 'application/json';
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// Add a response interceptor
axiosAPI.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            return error.response;
        }
    });

export default axiosAPI;